import styled from "styled-components";

export const VideoChipContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  background-color: ${({ theme }) => theme.colors.periwinkle[200]};
  color: ${({ theme }) => theme.colors.periwinkle[700]};
  padding: 10px;
  border-radius: 20px;
  margin: 0 4px;
`;
